import React from 'react';
import Styled from 'styled-components';

const Container = Styled.div`
display: flex;

@media (max-width: ${props => `${props.minWidth}px`}) {
  display: none;
}

@media (min-width: ${props => `${props.maxWidth}px`}) {
  display: none;
}
`;

const FlexMobileNotShow = (props) => {
  return (
    <Container {...props} minWidth={props.minWidth} maxWidth={props.maxWidth}>
        {props.children}
    </Container>
  )
}

export default FlexMobileNotShow;